export default STYLE_SETTINGS;
